"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _excluded = ["className", "field", "options", "object"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputText/index.js";
var defaultProps = {
  object: {},
  type: 'text'
};
function InputText(_ref) {
  var className = _ref.className,
    field = _ref.field,
    options = _ref.options,
    object = _ref.object,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  function onInput(e) {
    var value = e.target.value;
    object[field] = value;
  }
  var value = object[field];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("textarea", Object.assign({
    defaultValue: value,
    className: (0, _classNames["default"])('form-control', className),
    name: field,
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 14
    }
  })));
}
InputText.defaultProps = defaultProps;
var _default = InputText;
exports["default"] = _default;